import { Component, Input } from '@angular/core';
import { NavController } from 'ionic-angular';
import { Clipboard } from '@ionic-native/clipboard';
import { UtilsServiceProvider } from '../../providers/utils-service/utils-service';
import { ToastServiceProvider } from '../../providers/toast-service/toast-service';

@Component({
  selector: 'gift-card',
  templateUrl: 'gift-card.html'
})
export class GiftCardComponent {
  @Input() public item;

  minError: boolean = false;

  constructor(
    public navCtrl: NavController,
    private clipboard: Clipboard,
    public utilsService: UtilsServiceProvider,
    public toastService: ToastServiceProvider
  ) {}

  ngOnInit() {
    if (this.item.amount < 5) {
      this.minError = true;
    }
  }

  /**
   *Copy to clipboard
   *
   * @memberof GiftCardComponent
   */
  copyToClipboard() {
    if (this.utilsService.isDevice) {
      this.clipboard.copy(this.item.brand.brand);
    } else {
      let el = document.getElementById(
        this.item.brand.brand
      ) as HTMLInputElement;
      document.body.appendChild(el);

      if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
        // save current contentEditable/readOnly status
        const editable = el.contentEditable;
        const readOnly = el.readOnly;

        // convert to editable with readonly to stop iOS keyboard opening
        el.contentEditable = 'true';
        el.readOnly = true;

        // create a selectable range
        const range = document.createRange();
        range.selectNodeContents(el);

        // select the range
        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
        el.setSelectionRange(0, 999999);

        // restore contentEditable/readOnly to original state
        el.contentEditable = editable;
        el.readOnly = readOnly;
      } else {
        el.select();
      }

      document.execCommand('copy');
      document.body.removeChild(el);
    }
    this.toastService.show('Store copy to clipboard');
  }

  /**
   * Go to email page
   *
   * @memberof GiftCardComponent
   */
  gotoCheckout() {
    if (!this.minError) {
      this.navCtrl.push('SendEmailMyGiftPage', { item: this.item });
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/gift-card/gift-card.ts